
const localStorage = window.localStorage
let hasLocalStorage
let _storage = {}

try {
  hasLocalStorage = ('localStorage' in window) && localStorage !== null
  localStorage.setItem('test', 'test')
  localStorage.getItem('test')
  localStorage.removeItem('test')
} catch (e) {
  hasLocalStorage = false
}

let STORAGE = {
  get: function (key) {
    let obj
    let value
    if (hasLocalStorage) {
      value = localStorage.getItem(key)
    } else {
      value = _storage[key]
    }
    if (value) {
      try {
        obj = JSON.parse(value)
      } catch (e) {
        return null
      }
    }
    if (obj && obj.data) {
      if (!('expire' in obj) || obj.expire > new Date()) {
        return obj.data
      }
      this.remove(key)
    }
    return null
  },
  set: function (key, value, expire) {
    let obj = { data: value }
    let str
    if (expire > 0) {
      obj.expire = +new Date() + expire
    }
    str = JSON.stringify(obj)
    if (hasLocalStorage) {
      localStorage.setItem(key, str)
    } else {
      _storage[key] = str
    }
    return value
  },
  remove: function (key) {
    if (hasLocalStorage) {
      localStorage.removeItem(key)
    } else {
      delete _storage[key]
    }
  },
  removeInclueKey: function (key) {
    let data
    let k
    if (hasLocalStorage) {
      data = localStorage || {}
    } else {
      data = _storage
    }
    for (k in data) {
      if (k.indexOf(key) > -1) {
        this.remove(k)
      }
    }
  },
  removeExpired: function () {
    Object.keys(localStorage).forEach(function (key) {
      this.get(key)
    }, STORAGE)
  },
  clear: function () {
    if (hasLocalStorage) {
      try {
        window.localStorage.clear()
      } catch (e) {
        _storage = {}
      }
    } else {
      _storage = {}
    }
  }
}

if (hasLocalStorage) {
  STORAGE.removeExpired()
}

export default STORAGE
